import { logger } from './lib/logger.instance';

export * from './lib/buffered-logger';
export * from './lib/logger.instance';

// only attach the function to en-/disable the debug mode to the window object,
// if we are running in a browser environment
if (!logger.IS_BACKEND_ENV) {
  globalThis.enableDebugMode = logger.enableDebugMode.bind(logger);
  globalThis.disableDebugMode = logger.disableDebugMode.bind(logger);
}
